import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WsgSharedModule } from '@morningstar/wsg/shared';
import { SortablejsModule } from 'ngx-sortablejs';
import { DashboardComponent } from './/dashboard/dashboard.component';
import { CheckInsModule } from './check-ins/check-ins.module';
import { DashboardContainerComponent } from './dashboard-container/dashboard-container.component';
import { DashboardOutletDirective } from './dashboard-outlet.directive';
import { DashboardService } from './dashboard/dashboard.service';
import { FixedChargesModule } from './fixed-charges/fixed-charges.module';
import { MailForwardingModule } from './mail-forwarding/mail-forwarding.module';
import { MeetingRoomsModule } from './meeting-rooms/meeting-rooms.module';
import { RevenueByCategoryModule } from './revenue-by-category/revenue-by-category.module';
import { RevenueTotalModule } from './revenue-total/revenue-total.module';
import { TodoModule } from './todo/todo.module';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardOutletDirective,
    DashboardContainerComponent
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    DragDropModule,
    RevenueTotalModule,
    RevenueByCategoryModule,
    FixedChargesModule,
    MeetingRoomsModule,
    CheckInsModule,
    MailForwardingModule,
    SortablejsModule,
    TodoModule
  ],
  exports: [
    DashboardComponent
  ],
  providers: [
    DashboardService
  ]
})
export class DashboardModule { }
